/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
const o = {
  vertical: "top",
  horizontal: "left"
}, t = {
  vertical: "top",
  horizontal: "right"
}, i = {
  vertical: "flip",
  horizontal: "fit"
}, l = {
  vertical: "fit",
  horizontal: "flip"
}, n = {
  downward: {
    anchorAlign: {
      vertical: "bottom",
      horizontal: "right"
    },
    popupAlign: t,
    collision: i
  },
  leftward: {
    anchorAlign: {
      vertical: "top",
      horizontal: "left"
    },
    popupAlign: t,
    collision: l
  }
}, r = {
  downward: {
    anchorAlign: {
      vertical: "bottom",
      horizontal: "left"
    },
    popupAlign: o,
    collision: i
  },
  rightward: {
    anchorAlign: {
      vertical: "top",
      horizontal: "right"
    },
    popupAlign: o,
    collision: l
  }
};
export {
  r as POPUP_SETTINGS,
  n as POPUP_SETTINGS_RTL
};
